import { render, staticRenderFns } from "./FutureLayerIconAndWarningWrapper.vue?vue&type=template&id=791520e3&scoped=true&"
import script from "./FutureLayerIconAndWarningWrapper.vue?vue&type=script&lang=ts&"
export * from "./FutureLayerIconAndWarningWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./FutureLayerIconAndWarningWrapper.vue?vue&type=style&index=0&id=791520e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791520e3",
  null
  
)

export default component.exports